const MAX_RETRIES = 3;
const INITIAL_DELAY = 1000;

const exponentialBackoff = async (fn, delay = INITIAL_DELAY, retries = 0) => {
  try {
    const result = await fn();

    return result;
  } catch (error) {
    if (retries < MAX_RETRIES) {
      if (error.response && error.response.status === 429) {
        const nextDelay = delay * 2;
        await new Promise((resolve) => setTimeout(resolve, delay));

        return exponentialBackoff(fn, nextDelay, retries + 1);
      } else {
        throw error;
      }
    } else {
      throw error;
    }
  }
};

export default exponentialBackoff;
